import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { StorageService } from './services/storage.service';
import { EventBusService } from './shared/event-bus.service';
import {MatSidenav} from "@angular/material/sidenav";
import {BreakpointObserver} from "@angular/cdk/layout";
import {Location} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  @ViewChild(MatSidenav)
  sidenav!: MatSidenav;
  isMobile= true;
  noMenu = false;
  isCollapsed = true;

  private roles: string[] = [];
  isLoggedIn = false;
  showAdminBoard = false;
  showModeratorBoard = false;
  username?: string;
  email?: string;
  path: string = '';
  customerIntegrations: any[] = [];

  eventBusSub?: Subscription;
  title = "WE7 vivenu Integration";

  constructor(
    private storageService: StorageService,
    private eventBusService: EventBusService,
    private observer: BreakpointObserver,
    private location: Location,
    private translate: TranslateService
  ) {
    this.translate.addLangs(['de', 'en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    if (this.location.path() == '/login' || this.location.path() == '/register') {
      this.noMenu = true;
    }
    this.path = this.location.path();

    this.observer.observe(['(max-width: 800px)']).subscribe((screenSize) => {
      this.isMobile = screenSize.matches;
    });

    this.customerIntegrations = this.storageService.getCustomerIntegrations();

    this.isLoggedIn = this.storageService.isLoggedIn();

    if (this.isLoggedIn) {
      const user = this.storageService.getUser();
      this.roles = user.roles;

      this.showAdminBoard = this.roles.includes('ROLE_ADMIN');
      this.showModeratorBoard = this.roles.includes('ROLE_MODERATOR');

      this.username = user.username;
      this.email = user.email;
    }

    this.eventBusSub = this.eventBusService.on('logout', () => {
      this.logout();
    });
  }

  toggleMenu() {
    if(this.isMobile){
      this.sidenav.toggle().then();
      this.isCollapsed = false; // On mobile, the menu can never be collapsed
    } else {
      this.sidenav.open().then(); // On desktop/tablet, the menu can never be fully closed
      this.isCollapsed = !this.isCollapsed;
    }
  }

  logout(): void {
    // this.authService.logout().subscribe({
    //  next: res => {
          this.storageService.clean();

    window.location.reload();
    // this.router.navigate(['/login']).then();
    /*  },
      error: err => {
        console.log(err);
      }
    });*/
  }

  changeLanguage(localeCode: string): void {
    this.translate.use(localeCode);
  }
}
